// Where to send a user after sign-in. If they were bounced to the login page
// from a protected route (PrivateRoute passes it as `state.from`), return them
// there — but only to an in-app path their role can use. Anything else falls
// back to the role's home page.

export const FIELD_HOME = "/field-shifts";
export const DEFAULT_HOME = "/dashboard";

export const isFieldOnlyUser = (groups = []) =>
  groups.includes("fieldUser") && groups.length === 1;

const isFieldPath = (pathname) =>
  pathname === FIELD_HOME || pathname.startsWith(`${FIELD_HOME}/`);

export const getPostLoginPath = (groups = [], from) => {
  const fieldOnly = isFieldOnlyUser(groups);
  const fallback = fieldOnly ? FIELD_HOME : DEFAULT_HOME;
  const pathname = from?.pathname;

  // Same-origin paths only: "//host" and "/\host" are treated as other sites
  if (typeof pathname !== "string" || !/^\/(?![/\\])/.test(pathname)) {
    return fallback;
  }

  // Never loop back to the landing/login page
  if (pathname === "/" || pathname === "/login") return fallback;

  // Field users only have the field pages
  if (fieldOnly && !isFieldPath(pathname)) return fallback;

  return pathname + (from.search || "") + (from.hash || "");
};

// A forced sign-out (expired token, 401, idle timeout) reloads the page, which
// drops router state. Keep the page the user was on for the current tab so
// the login page can send them back after they sign in again.
const RETURN_KEY = "postLoginReturn";

export const saveReturnPath = ({ pathname, search, hash } = {}) => {
  if (!pathname || pathname === "/" || pathname === "/login") return;
  try {
    sessionStorage.setItem(RETURN_KEY, JSON.stringify({ pathname, search, hash }));
  } catch {
    // Storage unavailable (private mode, quota) — fall back to role home
  }
};

export const readReturnPath = () => {
  try {
    const raw = sessionStorage.getItem(RETURN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearReturnPath = () => {
  try {
    sessionStorage.removeItem(RETURN_KEY);
  } catch {
    // ignore
  }
};
